import * as yup from "yup";

export const createCategorySchema = yup.object().shape({
  categoryName: yup.string().trim().required("Category name is required"),
  categoryIcon: yup.mixed().required("Icon is required"),
   categoryImage: yup.mixed().nullable()
});
